import { Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormArea = styled(Form)`
    width: 100%;
    height: 100%;
`;

export default StyledFormArea;
